import * as React from "react"

class Header extends React.Component {
  render() {
    return (
      <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 8H18" stroke="#FFFFE7"/>
        <path d="M7.97838 0C7.97838 4.39024 4.37838 8 0 8" stroke="#FFFFE7"/>
        <path d="M0 8C4.37838 8 7.97838 11.6098 7.97838 16" stroke="#FFFFE7"/>
      </svg>
    )
  }
} 

export default Header

